"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTargetType = void 0;
var ExternalTargetType;
(function (ExternalTargetType) {
    ExternalTargetType["ROBOTA"] = "robota";
    ExternalTargetType["CONCUR"] = "concur";
    ExternalTargetType["COUPA"] = "coupa";
    ExternalTargetType["ARIBA"] = "ariba";
    ExternalTargetType["REGISTERED_COMPANY"] = "registered-company";
    ExternalTargetType["WORKFLOW"] = "workflow";
})(ExternalTargetType = exports.ExternalTargetType || (exports.ExternalTargetType = {}));
